module.exports = __webpack_public_path__ + "img/footer.28af8620.png";